import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";

const ListFiles = ({ index, allFiles, setValue, getValues }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const { newFiles } = allFiles(index);
    setFiles(newFiles || []);
  }, [allFiles, index]);

  const removeFile = (ind) => {
    const currentFiles = getValues(`cars.${index}.filesUrl`) || [];
    const fileToRemove = files[ind];

    const updatedFiles = files.filter((_, index) => index !== ind);
    const updatedAllFiles = currentFiles.filter(file => file !== fileToRemove);

    setFiles(updatedFiles);
    setValue(`cars.${index}.filesUrl`, updatedAllFiles, { shouldValidate: true });
  };

  return (
    <div className="grid md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-4 xl:grid-cols-4 sm:grid-cols-2 gap-x-4 mt-3">
      {files?.map((file, i) => (
        <div key={i} className="border border-[#999999] rounded-[5px] flex items-center justify-center relative">
          <div
            onClick={() => window.open(file, '_blank')}
            className="underline text-[#3E0292] font-400 cursor-pointer"
          >
            {t('myOrders.file')} {i + 1}
          </div>
          <div
            className="bg-[#ffffff] flex items-center justify-center cursor-pointer rounded-full w-[15px] h-[15px] absolute top-[-10px] right-[-10px]"
            onClick={() => removeFile(i)}
          >
            <FaTimes className="text-[#ff0000] text-[12px]" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListFiles;
